import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
const purchases = [{
  name: 'Camila G.',
  country: 'México'
}, {
  name: 'Santiago R.',
  country: 'Colombia'
}, {
  name: 'Valentina M.',
  country: 'Chile'
}, {
  name: 'Javier P.',
  country: 'España'
}, {
  name: 'Lucía A.',
  country: 'Argentina'
}];
export function RecentPurchaseNotification() {
  const [purchaseIndex, setPurchaseIndex] = useState(0);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setPurchaseIndex(current => (current + 1) % purchases.length);
    }, 9000);
    return () => window.clearInterval(interval);
  }, []);
  const purchase = purchases[purchaseIndex];
  return <div className="pointer-events-none fixed bottom-24 left-3 z-40 w-[calc(100%-1.5rem)] max-w-[290px] sm:bottom-5 sm:left-5" data-id="element-182" data-mp="151tejzslyubb">
      <AnimatePresence mode="wait" data-id="element-183" data-mp="19ttevtclbp8f">
        <motion.div key={purchase.name} initial={{
        opacity: 0,
        x: -18,
        y: 8
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -12,
        y: 8
      }} transition={{
        duration: 0.28
      }} className="flex items-center gap-3 rounded-xl border border-cyan-300/25 bg-[#071927]/95 p-3 shadow-xl backdrop-blur" aria-live="polite" data-id="element-184" data-mp="19uwa2dgy4du5">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-cyan-300/15 text-cyan-300" data-id="element-185" data-mp="6bmgsirpvdnz">
            <ShoppingBagIcon className="h-4 w-4" aria-hidden="true" data-id="element-186" data-mp="l7c54nkdk2vv" />
          </span>
          <p className="text-xs leading-snug text-slate-300" data-id="element-187" data-mp="gb3k4tjhxfgs">
            <strong className="font-semibold text-white" data-id="element-188" data-mp="2n004gltwe66d">
              {purchase.name}
            </strong>{' '}
            de {purchase.country} acaba de acceder a{' '}
            <span className="text-cyan-200" data-id="element-189" data-mp="37q3yysv1vd61">Mapa Maestro</span>.
          </p>
        </motion.div>
      </AnimatePresence>
    </div>;
}